import styled from 'styled-components';

const ConfigWrapper = styled.div`
	.header-label {
		padding: 1rem 0rem;
	}
	.title {
		font-size: 20px;
		font-weight: bold;
		color: #ffffff;
	}
	.switch-label {
		font-size: 12px;
		margin: 0px 5px;
		color: #ffffff;
	}
	.green-label {
		font-size: 10px;
		color: #1D79C9;
	}
	.save-label {
		position: relative;
		top: 0px;
		height: 0px;
	}
	.save-annual {
		width: 50px;
	}
	.select-btn {
		margin: 1rem 0rem;
		width: 100%;
		.ant-btn {
			width: 100%;
		}
		.flex-direction-column {
			flex-direction: column;
		}
		.requirement-icon {
			margin: 0.25rem 0rem;
			width: 2rem;
		}
		.de-select-status {
			border-radius: 50%;
			border: 1px solid #A8A8B1;
			height: 2rem;
			width: 2rem;
			cursor: pointer;
		}
		.no-cursor {
			cursor: not-allowed;
		}
		.de-select-status-txt {
			color: #545454;
		}
		.selected-status {
			color: #178700;
			font-weight: bold;
			margin: 0.25rem 0rem;
		}
	}
	.d-flex {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.switch-wrapper {
		margin: 1rem 0rem;
		.switch-content {
			display: flex;
			flex-direction: column;
		}
		.ant-switch {
			min-width: 46px;
			height: 23px;
			background-color: #0E0E0F;
		}
		.ant-switch-loading-icon, .ant-switch::after {
			background-color: #3A4FFF;
		}
		.label-inactive {
			color: #CCCCCC;
		}
	}
	.price-container {
		width: 50%;
		position: relative;
		left: 9rem;
		.cloud-plan-img {
    		width: 20px;
			position: absolute;
			right: 0.5rem;
			top: 0.5rem;
    		cursor: pointer;
		}
	}
	.box-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		.content-wrapper {
			display: flex;
			height: 98%;
			margin-top: 0.75rem;
		}
		.selected-content-wrapper {
			display: flex;
			height: 103%;
			.content {
				border-width: 2px;
			}

			.popular-label {
				top: 0.75rem;
			}
		}
		.content-divider {
			border-left: 1px solid #A8A8B1;
			border-right: 1px solid #A8A8B1;
		}
		.header-align {
			position: relative;
			left: 11.8rem;
		}
		
		.content {
			display: flex;
			flex-direction: column;
			align-items: center;
			// padding: 1rem 1.5rem;
			margin: 0rem 0.5rem;
			border-left: 2px solid #A8A8B1;
			border-top: 2px solid #A8A8B1;
			border-bottom: 2px solid #A8A8B1;
			.amount-label {
				margin-top: 1rem;
				font-weight: bold;
				color: #ffffff;
				font-size: 20px;
			}
			.ant-divider {
				width: 50% !important;
    			min-width: 0;
    			margin: 0;
			}
			.inner-content {
				margin: 1rem 0;
				.sub-header {
					font-weight: bold;
					color: #ffffff;
					text-align: left;
					margin-left: 2.2rem;
				}
			}
			.sub-txt {
						color: #fff;
					}
			.amount-wrapper {
				height: 4.5rem;
				text-align: center;
				.small-text {
					font-size: 10px;
				}
			}
			.center-flex-content {
				font-size: 12px;
				display: flex;
				flex-direction: column;
				align-items: center;
			}
		}
	}
	.box-container.inc-padding {
    	padding: 0 8rem;
	}
	.flex-space-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
		border-right: 2px solid #A8A8B1;
		.header_section {
			padding: 1rem;
			/* border-bottom: 1px solid #A8A8B1; */
			.diy-wrapper {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				.diy-icon {
					width: 50px;
				}
			}
		}
		.info-link-content {
			text-align: center;
    		text-decoration: underline;
			color: #3A4FFF;
			span {
				cursor: pointer;
			}
		}
		.header_section.blue-bg {
    		background-color: #29292C;
		}
		
		.title {
			text-align: center;
		}
		.small-text {
			color: #ffffff;
			font-size: 14px;
			text-align: center;
		}
		.plan-img{
			background-size: cover;
			background-position: center;
			background-repeat: no-repeat;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			height: 150px;
			padding: 1rem;
			justify-content: start;
		}
	}
	.center-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 1rem;
		font-size: 12px;
	}
	.popular-container {
		position: relative;
		display: flex;
		flex: 1;
		opacity: 0.5;

		.popular-label {
			top: 0.75rem;
		}
	}
	.selected-popular-container {
		opacity: 1;

	.popular-label {
			top: 0rem;
		}
	}
	.popular-header-basic {
	background-color: #C4C8AC;
	height: 15px;
	}
	.popular-header-crypto {
		background-color: #5CB5F9;
		color: #000;
		font-size: 10px;
		text-align: center;
	}
	.popular-header-fiat {
		background-color: #00FFFF;
		height: 15px;
	}
	.popular-label {
		position: absolute;
		top: 0rem;
		margin: 0rem 0.5rem;
		width: calc(100% - 1rem);
	}
	.popular-header {
		background-color: #5CB5F9;
		color: #000000;
		font-size: 10px;
		text-align: center;
	}
	.back-btn {
		margin-top: 1rem;
		width: 100%;
	}
	.footer {
		color: #A8A8B1;
		font-size: 16px;
    	margin-top: 3rem;
		.mb-1 {
			margin-bottom: 1rem;
		}
	}
	.footer-paid {
		font-size: 24px;
		font-weight: bold;
	}
	.btn-container {
		justify-content: space-between;
		.ant-btn {
			font-size: 12px;
    		width: 300px;
		}
	}
	.anticon {
		font-size: 25px;
		margin-right: 10px;
	}
	.success-msg {
		text-align: center;
		font-size: 16px;
		margin-top: 1rem;
		color: #00A451;
	}
	.button-wrapper {
		margin: 1rem 0rem;
		.back-btn {
			background-color: #4C00FF;
		}
		.separator {
			margin: 0px 1rem;
		}
	}
	@media(max-width: 960px) {
		.payment-container {
		}
		.steps-content-wrapper {
			padding: 0rem 1rem !important;
		}
		.box-container {
			.content-wrapper {
				flex-wrap: wrap;
				justify-content: space-around;

				.popular-container {
					margin-bottom: 1.5rem;
					min-width: 17rem;
					max-width: 17rem;
				}
				.content {
					border: 2px solid #A8A8B1 !important;
				}
			}
		}
	}
`
export default ConfigWrapper

export const PayConfirmWrapper = styled.div`
	padding-top: 4rem;
	.success-img-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		.payment-success-img {
    		width: 70px;
		}
	}
	.main-content {
		font-size: 17px;
		font-weight: bold;
		text-align: center;
		color: #000000;
		padding: 0rem 2rem;
		margin-bottom: 1rem;
	}
	.sub-content {
		font-size: 11px;
		text-align: center;
		color: #000000;
	}
	.ant-btn {
		width: 100%;
		margin-top: 1rem;
	}
`